// Lib Imports
import React, { useContext, useState, useCallback, useMemo, useEffect } from 'react';
import { Box, Button, Heading, ResponsiveContext, Text, Image, Layer, Grid } from 'grommet';
import {
// Image as PreviewImage,
FormTrash, DocumentDownload, Document, DocumentExcel, DocumentPdf, DocumentCsv, DocumentImage } from 'grommet-icons';
import PropTypes from 'prop-types';
import Viewer from 'react-viewer';
import styled from 'styled-components';

// Core Imports
import Divider from 'granite-admin/core/components/Divider';
import Loader from 'granite-admin/core/components/Loader';
// import { DataTable } from 'granite-admin/core/components/TableV3';
import UploadFile from 'granite-admin/core/components/UploadFile';
import EventEmitter from 'granite-admin/utils/event-emitter';
import { useToast } from 'granite-admin/core/components/Toast';
import { ConfigContext } from '../ConfigProvider';
import NoRecordsPlaceholder from '../NoRecordsPlaceholder';
import Popconfirm from '../Popconfirm';

// Application Imports
// import * as OrganisationDucks from 'granite-admin/organisations/ducks/organisations';
import documentAPI from 'granite-admin/common/gateways/document-api';
// import { DOCUMENTS_COLUMNS } from 'granite-admin/common/controllers/constants';
import { uploadDocumentClicked } from 'granite-admin/common/controllers/documents';
// import PreviewPane from './components/PreviewPane';
import DocType from './components/docType';
import DocumentsSkeletonLoader from './components/DocumentsSkeletonLoader';
import CloseIcon from '../../../common/assets/CloseIcon';
import { VideoPreview, DocsPreview } from 'granite-admin/core/components/UploadFile/components/utils';
import { downloadFromUrl } from 'granite-admin/utils/functions';
const CloseBox = styled(Box)`
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0px;
  right: 0px;
  overflow: hidden;
  width: 40px;
  height: 40px;
  border-radius: 0 0 0 40px;
  cursor: pointer;
  z-index: 1010;
  &:hover {
    background-color: black;
  }
`;
const imageSize = '28px';
const Documents = ({
  objectId,
  contentTypeId,
  // selectedOrganisation,
  setShow,
  title,
  acceptedFiles,
  plain,
  // viewDefaultDoc,
  contentTypeName,
  fields = ['docType', 'docSubType'] //passed default options field in case no option field passed in extra_data
}) => {
  const size = useContext(ResponsiveContext);
  const {
    successToast,
    errorToast
  } = useToast();
  const eventEmitter = useMemo(() => new EventEmitter(), []);
  const [showUpload, setShowUpload] = useState(false);
  const [showType, setShowType] = useState(false);
  // const [document, setDocument] = useState({});
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fullscreen, setFullscreen] = useState(false);
  const [fileData, setFileData] = useState({
    files: []
  });
  // const ref = useRef();
  const config = useContext(ConfigContext);
  useEffect(() => {
    const subscription = eventEmitter.getObservable().subscribe(event => {
      switch (event.type) {
        case 'DOCUMENT_SAVE_SUCCESS':
          successToast(`Document(s) uploaded successfully`);
          break;
        case 'DOCUMENT_SAVE_FAILURE':
          errorToast('Failed to upload document!');
          break;
        case 'CONTENT_TYPE_SUCCESS':
          // setEntity(event.data);
          break;
        case 'CONTENT_TYPE_FAILURE':
          errorToast(event.data);
          break;
        default:
          break;
      }
    });
    return () => subscription.unsubscribe();
  }, [eventEmitter, successToast, errorToast]);
  const fetchDocs = useCallback(async data => {
    setLoading(true);
    let result = await documentAPI.getDocuments({
      ...data,
      target_content_type_id: contentTypeId,
      target_object_id: objectId
    });
    setLoading(false);
    return result;
  }, [objectId, contentTypeId]);
  useEffect(() => {
    async function init() {
      const result = await fetchDocs();
      setDocs(result.list);
    }
    init();
  }, [fetchDocs]);
  const handleUpload = useCallback(async (eventEmitter, values) => {
    await uploadDocumentClicked(eventEmitter, {
      ...values,
      file_name: values.file_name,
      target_content_type_id: contentTypeId,
      target_object_id: objectId,
      target_content_type_name: contentTypeName
    });
    setShowUpload(false);
    const result = await fetchDocs();
    setDocs(result.list);
  }, [objectId, contentTypeId, contentTypeName, errorToast, successToast]);
  const saveUpload = useCallback(async (eventEmitter, values) => {
    const obj = {
      ...values,
      file_name: values.file_name,
      target_content_type_id: contentTypeId,
      target_object_id: objectId,
      target_content_type_name: contentTypeName
    };
    setFileData(obj);
    setShowUpload(false);
    // return res;
  }, [objectId, contentTypeId, contentTypeName]);

  // const handleRowClick = ({ original }) => {
  //   setDocument(original);
  // };

  const deleteHandler = useCallback(async ({
    pk
  }) => {
    const data = await documentAPI.deleteDocument(pk);
    let result = docs;
    if (data) {
      result = result.filter(elem => elem.pk !== pk);
      successToast('Document deleted successfully');
      setDocs(result);
    } else errorToast('Unable to delete document');
    // return result;
  }, [docs, errorToast, successToast]);
  const loadDocument = () => {
    switch (fullscreen.extension) {
      case 'jpg':
      case 'jpeg':
      case 'png':
        {
          // const viewerProps = !fullscreen
          //   ? {
          //       noClose: true,
          //       downloadable: true,
          //       noImgDetails: true,
          //       noFooter: true,
          //       downloadInNewWindow: true,
          //       zoomable: true,
          //       visible: true,
          //       rotatable: false,
          //       noNavbar: true,
          //       noToolBar: true,
          //       onClose: () => setDocument({}),
          //       container: ref?.current,
          //       images: [{ src: fullscreen.document, alt: 'image' }],
          //       // ...options,
          //     }
          //   :
          const viewerProps = {
            noClose: false,
            noFooter: true,
            zoomable: true,
            visible: true,
            onClose: () => setFullscreen(false),
            images: [{
              src: fullscreen.document,
              alt: 'image'
            }]
            // ...options,
          };

          return /*#__PURE__*/React.createElement(Viewer, viewerProps);
        }
      case 'pdf':
        return /*#__PURE__*/React.createElement("iframe", {
          title: "document-pdf",
          src: fullscreen.document,
          width: "100%",
          height: "100%"
        });
      case 'mp4':
      case 'webm':
        return /*#__PURE__*/React.createElement(VideoPreview, {
          file: fullscreen.document
        });
      case 'ppt':
      case 'pptx':
      case 'doc':
      case 'docx':
      case 'xls':
      case 'xlsx':
        return /*#__PURE__*/React.createElement(DocsPreview, {
          file: fullscreen.document
        });
      default:
        return /*#__PURE__*/React.createElement(Text, null, "Preview not available");
    }
  };
  const fetchIcon = parameter => {
    switch (parameter) {
      case 'pdf':
        return /*#__PURE__*/React.createElement(DocumentPdf, {
          size: imageSize
        });
      case 'docx':
      case 'doc':
        return /*#__PURE__*/React.createElement(Document, {
          size: imageSize
        });
      case 'xlsx':
        return /*#__PURE__*/React.createElement(DocumentExcel, {
          size: imageSize
        });
      case 'csv':
        return /*#__PURE__*/React.createElement(DocumentCsv, {
          size: imageSize
        });
      case 'png':
      case 'jpg':
      case 'jpeg':
        return /*#__PURE__*/React.createElement(DocumentImage, {
          size: imageSize
        });
      default:
        return /*#__PURE__*/React.createElement(Document, {
          size: imageSize
        });
    }
  };
  return /*#__PURE__*/React.createElement(Layer, {
    full: "vertical",
    position: "right",
    onEsc: () => setShow(false)
    // onClickOutside={e => {
    //   if (e.target.getAttribute('class').includes('StyledLayer')) setShow(false);
    // }}
  }, /*#__PURE__*/React.createElement(Box
  // animation={{ type: 'slideLeft', duration: 500 }}
  , {
    width: size !== 'small' ? `${config.sliderWidth}` : 'auto',
    flex: "grow",
    background: "white",
    elevation: plain ? 'none' : 'medium',
    pad: {
      horizontal: plain ? 'none' : 'small',
      vertical: 'small'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    justify: "between",
    pad: {
      left: 'small'
    }
  }, /*#__PURE__*/React.createElement(Heading, {
    level: 3,
    size: "small",
    margin: "none"
  }, title), /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    justify: "between",
    align: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "small",
    primary: true,
    label: "Upload",
    onClick: () => setShowType(true)
  }), !plain && /*#__PURE__*/React.createElement(Box, {
    width: "25px",
    height: "25px",
    onClick: () => setShow(false),
    background: "transparent",
    justify: "center",
    align: "center",
    focusIndicator: false,
    style: {
      position: 'absolute',
      left: '-12px',
      top: '0px',
      overflow: 'hidden',
      borderRadius: '50%'
    }
  }, /*#__PURE__*/React.createElement(CloseIcon, null)))), /*#__PURE__*/React.createElement(Divider, {
    color: "brand",
    margin: {
      bottom: 'xsmall',
      top: 'xsmall'
    }
  }), /*#__PURE__*/React.createElement(Box, {
    gap: "small",
    pad: "small",
    flex: true,
    basis: "auto",
    height: "0px",
    overflow: {
      vertical: 'auto'
    }
  }, loading && config?.showSkeletonLoader ? /*#__PURE__*/React.createElement(DocumentsSkeletonLoader, null) : loading ? /*#__PURE__*/React.createElement(Box, {
    fill: true,
    align: "center",
    justify: "center"
  }, /*#__PURE__*/React.createElement(Loader, null)) : !loading && docs?.length > 0 ? docs?.map((elem, ind) => /*#__PURE__*/React.createElement(Box, {
    key: ind + 'doc-cards',
    pad: "small",
    gap: "medium",
    direction: size !== 'small' ? 'row' : 'column',
    background: "full-screen-background-color",
    width: "100%",
    justify: "between",
    elevation: "small",
    round: "xsmall",
    onClick: e => {
      if (e.target.tagName !== 'svg' && e.target.tagName !== 'path' && e.target.tagName !== 'BUTTON') setFullscreen(elem);
    },
    focusIndicator: false,
    flex: {
      shrink: 0
    }
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    gap: "small",
    align: "center"
  }, elem?.extension?.toLowerCase() === 'jpg' || elem?.extension?.toLowerCase() === 'png' || elem?.extension?.toLowerCase() === 'jpeg' ? /*#__PURE__*/React.createElement(Box, {
    height: "45px",
    width: "45px",
    align: "center"
  }, /*#__PURE__*/React.createElement(Image, {
    fit: "cover",
    src: elem?.document,
    width: "70%"
  })) :
  /*#__PURE__*/
  // <DropButton
  //   icon={fetchIcon(elem?.extension?.toLowerCase())}
  //   dropAlign={{ top: 'bottom' }}
  //   dropProps={{ round: 'small', elevation: 'medium', background: 'white' }}
  //   dropContent={
  //     <Box height="small" width="small" pad="small" justify="center" align="center">
  //       {elem.document ? (
  //         <Image fit="contain" fill src={elem.document} />
  //       ) : (
  //         <Text>No Image Preview</Text>
  //       )}
  //     </Box>
  //   }
  // />
  React.createElement(Box, {
    pad: "small"
  }, fetchIcon(elem?.extension?.toLowerCase())), /*#__PURE__*/React.createElement(Box, {
    gap: "small"
  }, /*#__PURE__*/React.createElement(Text, null, elem.name), /*#__PURE__*/React.createElement(Grid, {
    columns: size !== 'small' ? [['1/2', '1/2'], ['1/2', '1/2']] : '100%',
    gap: {
      column: 'large'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    style: {
      whiteSpace: 'nowrap'
    }
  }, /*#__PURE__*/React.createElement("b", null, "Type: "), elem.documentType), /*#__PURE__*/React.createElement(Text, {
    style: {
      whiteSpace: 'nowrap'
    }
  }, /*#__PURE__*/React.createElement("b", null, "Sub Type: "), elem.documentSubType)), /*#__PURE__*/React.createElement(Grid, {
    columns: size !== 'small' ? [['1/2', '1/2'], ['1/2', '1/2']] : '100%',
    gap: {
      column: 'large'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    style: {
      whiteSpace: 'nowrap'
    }
  }, elem.uploadedBy), /*#__PURE__*/React.createElement(Text, {
    style: {
      whiteSpace: 'nowrap'
    }
  }, elem.date)))), /*#__PURE__*/React.createElement(Box, {
    align: "center",
    justify: size !== 'small' ? 'end' : 'start',
    gap: "small",
    direction: "row"
  }, /*#__PURE__*/React.createElement(Popconfirm, {
    align: "bottom",
    onConfirm: () => deleteHandler(elem),
    title: "Are you sure you would like to delete this document?"
  }, /*#__PURE__*/React.createElement(FormTrash, {
    size: "24px",
    color: "brand",
    style: {
      cursor: 'pointer'
    }
  })), /*#__PURE__*/React.createElement(DocumentDownload, {
    color: "brand",
    size: "14px",
    style: {
      cursor: 'pointer',
      marginBottom: '2px'
    },
    onClick: () => downloadFromUrl(elem.document, `${elem.name}.${elem.extension}`)
  })))) : /*#__PURE__*/React.createElement(NoRecordsPlaceholder, {
    msg: "No Document Found"
  })), fullscreen && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layer, {
    full: true,
    onEsc: () => setFullscreen(false),
    background: "rgba(0, 0, 0, 0.5)"
  }, /*#__PURE__*/React.createElement(CloseBox, {
    onClick: () => setFullscreen(false)
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    color: "#fff",
    size: "18px"
  })), /*#__PURE__*/React.createElement(Box, {
    margin: "50px",
    fill: "vertical",
    align: "center",
    justify: "center"
  }, loadDocument()))), showUpload && /*#__PURE__*/React.createElement(UploadFile, {
    eventEmitter: eventEmitter,
    uploadFile: saveUpload,
    setLayer: setShowUpload,
    multiple: true,
    accept: acceptedFiles,
    title: "Upload Document",
    isDocUploaded: true
  }), showType && /*#__PURE__*/React.createElement(DocType, {
    eventEmitter: eventEmitter,
    uploadFile: handleUpload,
    handleLayerClose: () => setShowType(false),
    setShow: setShowUpload,
    fileData: fileData,
    setFileData: setFileData
    // entities={entity}
    ,
    fields: fields
  })));
};
Documents.propTypes = {
  eventEmitter: PropTypes.object,
  // selectedOrganisation: PropTypes.object,
  title: PropTypes.string,
  plain: PropTypes.bool,
  acceptedFiles: PropTypes.string,
  // viewDefaultDoc: PropTypes.bool,
  contentTypeName: PropTypes.string,
  setShow: PropTypes.func,
  fields: PropTypes.array,
  objectId: PropTypes.any,
  contentTypeId: PropTypes.any
};
Documents.defaultProps = {
  title: 'Documents',
  acceptedFiles: '.png,.jpg,.jpeg,.doc,.pdf,.mp4,.webm,.xlsx,.docx',
  plain: false
  // viewDefaultDoc: true,
};

export default Documents;